// extracted by mini-css-extract-plugin
export var fullWidthButton = "_fq-0";